interface EmployerAggregateRatingData {
  companyName: string
  ratingValue: number
  ratingCount: number
}

export function generateEmployerAggregateRatingSchema(data: EmployerAggregateRatingData) {
  if (!data.companyName || !data.ratingValue || !data.ratingCount) {
    return null
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'EmployerAggregateRating',
    'itemReviewed': {
      '@type': 'Organization',
      'name': data.companyName
    },
    'ratingValue': data.ratingValue,
    'ratingCount': data.ratingCount,
    'bestRating': 5,
    'worstRating': 1
  }
}
